import { useDispatch, useSelector } from 'react-redux';
import {
  setLink as setL,
  setOpen as setO,
  setShowFan2Fan as setSF,
  restore,
} from './fan2fan.slice';

export default function useExchange() {
  const dispatch = useDispatch();
  const { link, open } = useSelector((state) => state.fan2fan);

  const setLink = (link) => dispatch(setL(link));

  const setOpen = (value) => dispatch(setO(value));

  const setShowFan2Fan = ({ link, open }) => dispatch(setSF({ link, open }));

  const restoreFan2Fan = () => dispatch(restore());

  return {
    setShowFan2Fan,
    setLink,
    setOpen,
    open,
    link,
    restoreFan2Fan,
  };
}
